import { initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyAqHR1PEg3wToC_IpW2j76pLWbI4VKQMWA",
  authDomain: "gandolappdb.firebaseapp.com",
  databaseURL: "https://gandolappdb-default-rtdb.firebaseio.com",
  projectId: "gandolappdb",
  storageBucket: "gandolappdb.appspot.com",
  messagingSenderId: "461428824520",
  appId: "1:461428824520:web:1ffcaebdc9255eaf7688fd",
  measurementId: "G-K92YEMYHE7",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);
const functions = getFunctions(app, "europe-west6");

const isLocalHost =
  window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

const shouldUseEmulators =
  process.env.REACT_APP_FORCE_EMULATORS === "true" ||
  process.env.REACT_APP_USE_EMULATORS === "true" ||
  isLocalHost;

if (shouldUseEmulators) {
  const emulatorHost = process.env.REACT_APP_EMULATOR_HOST || "127.0.0.1";
  const firestorePort = Number(process.env.REACT_APP_FIRESTORE_EMULATOR_PORT || 8088);
  const authPort = Number(process.env.REACT_APP_AUTH_EMULATOR_PORT || 9092);
  const storagePort = Number(process.env.REACT_APP_STORAGE_EMULATOR_PORT || 9199);
  const functionsPort = Number(process.env.REACT_APP_FUNCTIONS_EMULATOR_PORT || 5051);

  connectFirestoreEmulator(db, emulatorHost, firestorePort);
  connectAuthEmulator(auth, `http://${emulatorHost}:${authPort}`);
  connectStorageEmulator(storage, emulatorHost, storagePort);
  connectFunctionsEmulator(functions, emulatorHost, functionsPort);
}

export { db, storage, auth, functions };
